import React, { Fragment } from 'react'
import {NavBar} from '../components/NavBar'
import { ProjectForm } from '../components/ProjectForm'
import './pages.css'

export const ProjectPage = () => {


  return (
    <Fragment>
      <div className="main">
      <NavBar/>
      <ProjectForm/>
      </div>
     
    </Fragment>
  )
}

